<template>
  <Modal v-model="visible" :width="960" :transfer="false" :mask-closable="false" class-name="vertical-center-modal" footer-hide>
    <template slot="header"> </template>
    <div class="c-warp">
      <video v-if="visible" :src="url" controls autoplay>您的浏览器不支持 video 标签</video>
    </div>
    <span slot="close" @click.stop="$emit('input', false)" class="c-close"></span>
  </Modal>
</template>
<script>
export default {
  name: 'Preview',
  props: {
    value: {
      type: Boolean
    },
    url: {
      type: String
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-warp {
  width: 960px;
  height: 540px;
  border-radius: 4px;
  background-color: #3b3b3b;

  video {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}

.c-close {
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-color: #ff0000;
  border-radius: 10px;
  line-height: 18px;
  text-align: center;

  &::before {
    content: 'x';
    color: #fff;
    display: inline-flex;
    font-family: 'element-icons';
    font-size: 14px;
    line-height: 15px;
  }
}

::v-deep .ivu-modal-close {
  top: -6px;
  right: -6px;
}

::v-deep .ivu-modal-body {
  padding: 0;
}
</style>
